import React from "react";
import { Box, Typography } from "@mui/material";
import MatchingDashboard from "../components/MatchingDashboard";

const MatchingDashboardPage: React.FC = () => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
      <Box>
        <Typography variant="h4" gutterBottom>
          Matching Dashboard
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Visualize estatísticas de matching entre faturas e transações.
        </Typography>
      </Box>
      <MatchingDashboard />
    </Box>
  );
};

export default MatchingDashboardPage;
